import React from 'react'
import { BottomModal, OptionsBottomModal } from '@components'
import { useNavigation } from '@react-navigation/native'
import { ScreenContactProps } from '@navigation'
import { useLanguage } from '@context'

type AddContactOptionsModalProps = {
  isVisible: boolean
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>
}

export const AddContactOptionsModal = ({
  isVisible,
  setIsVisible,
}: AddContactOptionsModalProps): React.ReactElement => {
  const navigation = useNavigation<ScreenContactProps<'AddContact'>['navigation']>()
  const { t } = useLanguage()

  const navigateToNetwork = (network: string) => {
    setIsVisible(false);
    (navigation as any).navigate('Contacts', {
      screen: 'FtSocialImportNetwork',
      params: { network },
    })
  }

  const options: OptionsBottomModal[] = [
    {
      title: t('contacts.searchProfile'),
      iconName: 'search',
      hasBackground: true,
      onPress: () => {
        setIsVisible(false);
        (navigation as any).navigate('Contacts', {screen: 'AddContact'})
      },
    },
    {
      title: t('contacts.addNonExistingProfile'),
      iconName: 'frame',
      onPress: () => {
        setIsVisible(false);
        (navigation as any).navigate('Profile', {
          screen: 'AddGhostContact'
        })
      },
    },
    {
      title: t('common.scanBusinessCard'),
      iconName: 'scan',
      onPress: () => {
        setIsVisible(false);
        (navigation as any).navigate('Contacts', {
          screen: 'CardScanner'
        })
      },
    },
    {
      title: t('contacts.importFromContacts'),
      iconName: 'userPlus',
      onPress: () => {
        setIsVisible(false);
        (navigation as any).navigate('Contacts', { screen: 'ImportContacts'})
      },
    },
    {
      title: t('contacts.importFrom', { network: 'Instagram' }),
      iconName: 'instagram',
      onPress: () => navigateToNetwork('instagram'),
    },
    {
      title: t('contacts.importFrom', { network: 'Facebook' }),
      iconName: 'facebook',
      onPress: () => navigateToNetwork('facebook'),
    },
    {
      title: t('contacts.importFrom', { network: 'Twitter / X' }),
      iconName: 'twitter',
      onPress: () => navigateToNetwork('twitter'),
    },
    {
      title: t('contacts.importFrom', { network: 'LinkedIn' }),
      iconName: 'linkedin',
      onPress: () => navigateToNetwork('linkedin'),
    },
  ]

  return <BottomModal isVisible={isVisible} options={options} setIsVisible={setIsVisible} fullScreen />
}
